export default "__VITE_ASSET__9f286c2d__"